let timelineElements = [
  {
    id: 1,
    title: "CLASS X",
    location: "NAVY CHILDREN SCHOOL",
    description:
      "PORT BLAIR",
    buttonText: "",
    date: "APRIL 2017",
    icon: "school",
  },
  {
    id: 2,
    title: "CLASS XII",
    location: "NAVY CHILDREN SCHOOL",
    description:
      "PORT BLAIR",
    buttonText: "",
    date: "APRIL 2019",
    icon: "school",
  },
  {
    id: 3,
    title: "BACHELORS OF TECHNOLOGY",
    location: "NATIONAL INSTITUTE OF TECHNOLOGY (NIT DURGAPUR)",
    description:
      "DURGAPUR",
    buttonText: "",
    date: "AUGUST 2019",
    icon: "school",
  },
  {
    id: 4,
    title: "JUNIOR COORDINATOR",
    location: "ENTREPRENEURSHIP DEVELOPMENT CELL (EDC)",
    description:
      "DURGAPUR",
    buttonText: "",
    date: "September 2019",
    icon: "work",
  },
  {
    id: 5,
    title: "INTERNSHIP",
    location: "Space Technology and Aeronautical Rocketry",
    description:
      "REMOTE",
    buttonText: "",
    date: "DEC 2021 - JAN 2022",
    icon: "work",
  },
  {
    id: 6,
    title: "CAMPUS DIRECTOR",
    location: "HULT PRIZE ",
    description:
      "NIT DURGAPUR",
    date: "APRIL 2022",
    icon: "work",
  },
  {
    id: 7,
    title: "GENERAL SECRETARY",
    location: "ENTREPRENEURSHIP DEVELOPMENT CELL (EDC)",
    description:
      "DURGAPUR",
    date: "MAY 2022",
    icon: "work",
  },
  {
    id: 8,
    title: "GRADUATION",
    location: "NATIONAL INSTITUTE OF TECHNOLOGY (NIT DURGAPUR)",
    description:
      "DURGAPUR",
    date: "MAY 2023",
    icon: "school",
  },
  {
    id: 9,
    title: "DIPLOMA IN ADVANCE COMPUTING",
    location: "CDAC ACTS",
    description:
      "PUNE",
    date: "SEPT 2023-APRIL 2024",
    icon: "school",
  },
];

export default timelineElements;
